import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/was-ist-oopbuy-spreadsheet/page";
import EinrichtungPage from "@/pages/oopbuy-spreadsheet-einrichtung/page";
import QCGuidePage from "@/pages/oopbuy-qc-guide/page";
import VersandPage from "@/pages/oopbuy-versand-deutschland/page";
import AgentPage from "@/pages/oopbuy-agent-vergleich/page";
import TaobaoPage from "@/pages/oopbuy-taobao-guide/page";
import WeidianPage from "@/pages/oopbuy-weidian-guide/page";
import YupooPage from "@/pages/oopbuy-yupoo-guide/page";
import SparenPage from "@/pages/oopbuy-kosten-sparen/page";
import BatchPage from "@/pages/oopbuy-batch-bestellungen/page";
import EinkaufsfuehrerPage from "@/pages/einkaufsfuehrer/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/was-ist-oopbuy-spreadsheet",
    element: <ArticlePage />,
  },
  {
    path: "/einkaufsfuehrer",
    element: <EinkaufsfuehrerPage />,
  },
  {
    path: "/oopbuy-spreadsheet-einrichtung",
    element: <EinrichtungPage />,
  },
  {
    path: "/oopbuy-qc-guide",
    element: <QCGuidePage />,
  },
  {
    path: "/oopbuy-versand-deutschland",
    element: <VersandPage />,
  },
  {
    path: "/oopbuy-agent-vergleich",
    element: <AgentPage />,
  },
  {
    path: "/oopbuy-taobao-guide",
    element: <TaobaoPage />,
  },
  {
    path: "/oopbuy-weidian-guide",
    element: <WeidianPage />,
  },
  {
    path: "/oopbuy-yupoo-guide",
    element: <YupooPage />,
  },
  {
    path: "/oopbuy-kosten-sparen",
    element: <SparenPage />,
  },
  {
    path: "/oopbuy-batch-bestellungen",
    element: <BatchPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;